import React from "react";
import { useTranslation } from "react-i18next";
import { redirectUserToHomePageAfterRegistration } from "@utils";
import { OnBoardingSlider, OnBoardingFooter } from "../shared";
import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { HeaderType } from "@data-types/layout/headerTypeEnum";

export default function OnboardingRegistrationError() {
	const { t } = useTranslation("registration");

	const redirectToHomePage = () => {
		redirectUserToHomePageAfterRegistration();
	};

	return (
		<DesktopLayout
			headerType={HeaderType.EMPTY}
			mainClassName="at-registrationError l--membership"
		>
				<section className="l--content l--content--full">
					<div className="l--content__main u-padd--reset">
						<div className="l--membership__container">
							<div className="card--membership card--primary">
								<OnBoardingSlider hasOnboardingStyling={true} />

								<div className="card--membership__main">
									<div className="card--membership__message">
										<div className="card--membership__header u-display--f--col u-mar--bottom--med">
											<i className="u-icon u-icon--xlrg u-icon--remove-circle u-icon--animated--bounce-in u-color--sent--danger" />
											<div className="card--membership__title u-mar--top--xsml">
												{t("ERROR_HAS_OCCURED")}
											</div>
										</div>

										<div className="u-type--center">
											{t("GENERIC_ERROR")}
										</div>
									</div>

									<button
										type="button"
										className="at-regErrorBtn btn btn--base btn--block btn--accent"
										onClick={redirectToHomePage}
									>
										{t("COMMON.OK_BTN")}
									</button>
								</div>
							</div>

							<OnBoardingFooter hasOnboardingStyling={true} />
						</div>
					</div>
				</section>
		</DesktopLayout>
	);
}
